import { type StatsItem } from "../models";

export const sortStatsArray = (list: StatsItem[]): StatsItem[] => list.sort((a, b) => (a.value < b.value ? 1 : -1));
